import React from 'react'
import { FcApproval } from 'react-icons/fc'
import { BsFacebook, BsYoutube, BsInstagram } from 'react-icons/bs'
import './ReviewModal.css'
import { useNavigate } from 'react-router-dom'

const ReviewModal = () => {
const navigate = useNavigate()

const toGallery = () => {
    navigate('/gallery', { replace: true })
}
return (
    <div className="review-modal-container">
    <FcApproval className="review-success-icon" />
    <div className="review-gallery-div">
        <h1>Thank You!</h1>
        <h3>
        Your review was submitted successfully. We appreciate your feedback.
        </h3>
        <h4>
        Be sure to check out our gallery for ideas on your next project!
        </h4>

        <button className="review-modal-btn" onClick={toGallery}>
        Gallery
        </button>

        <h4>Follow Us:</h4>
    </div>
    <div className="review-icon-container">
        <BsFacebook className="review-icon" />
        <BsYoutube className="review-icon" />
        <BsInstagram className="review-icon" />
    </div>
    </div>
)
}

export default ReviewModal


